import ExternalSettingsDataStore from '../../datastores/ExternalSettingsDataStore';

export default class ExternalSettingsDataStoreMock
  implements ExternalSettingsDataStore
{
  async getStudentPortalSettings() {
    const data1 = {
      studentPortal: {
        isCourseCatalog: false,
        isProgressiveCertification: false,
        isRolExam: true,
        isEnrollmentTurn: true
      },
      config:
        '{"enrollment_enabled":"true","enrollment_period_code":"2243","enrollment_period_name":"Marzo 2024","enrollment_start_classes":"2024-01-01","enrollment_end_enrollment":"2024-01-12T05:00:00.000Z","enrollment_url":"https://www.utp.edu.pe/matricula","sae_phone":"960252970","current_utp_period":"2242","apolo13_academics_core":"false","apolo13_payments_core":"false","apolo13_people_core":"false","backend_keycloack":"false","enrollment_button_portal":"true","portal_enable_exams":"true","modality_ranges_P":"0-20","modality_ranges_SP":"21-70","modality_ranges_D":"71-100","enable_popup_documents":"true","dates_by_periods":"[{\\"period\\":\\"2241\\",\\"startDate\\":\\"2025-01-06\\"},{\\"period\\":\\"2242\\",\\"startDate\\":\\"2025-03-24\\"}]","enable_popup_survey":"true","enable_rol_examenes":"true","enable_catalogo_cursos":"true","enable_intension_matricula":"true"}'
    };
    return data1;
  }

  getBannerList() {
    const data = {
      bannerList: [
        {
          id: 18974,
          urlRef: 'https://google.com',
          image: null,
          imageUrl:
            'https://res.cloudinary.com/dcwq9jz8t/image/upload/v1652411104/utp/template/logo_p9yatu.svg'
        },
        {
          id: 18975,
          urlRef: null,
          image: null,
          imageUrl:
            'https://res.cloudinary.com/dcwq9jz8t/image/upload/v1652411104/utp/template/logo_p9yatu.svg'
        },
        {
          id: 18976,
          urlRef: null,
          image: null,
          imageUrl:
            'https://res.cloudinary.com/dcwq9jz8t/image/upload/v1652411104/utp/template/logo_p9yatu.svg'
        }
      ]
    };
    return data.bannerList;
  }

  getBannerDetail(bannerId: number) {
    const data = {
      bannerDetail: {
        id: bannerId,
        urlRef: 'https://utp.edu.pe',
        image: null
      }
    };
    return data.bannerDetail;
  }

  getLinksInterest() {
    const data = {
      linksInterest: [
        {
          name: 'Boletín',
          urlRef: 'https://bit.ly/BoLima'
        },
        {
          name: 'Bolsa de trabajo',
          urlRef: 'https://bit.ly/hiringroom'
        }
      ]
    };
    return data.linksInterest;
  }

  getVersion() {
    const data = {
      lastVersion: {
        version: '1.0.0',
        buildTime: '2023-08-01T00:00:00.000Z'
      }
    };
    return data.lastVersion;
  }
}
